import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthGuard, I18nModule, provideConfig, UrlModule } from '@spartacus/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { CanDeactivateFn, RouterModule } from '@angular/router';
import { IconModule, FormErrorsModule, KeyboardFocusModule, MediaModule, CmsPageGuard } from '@spartacus/storefront';
import { KbQuickorderformComponent } from './kb-quickorderform.component';
import { KbQuickorderErrPopupComponent } from './kb-quickorder-err-popup/kb-quickorder-err-popup.component';
import { AddtocartPopupConfirmationComponent } from './addtocart-popup-confirmation/addtocart-popup-confirmation.component';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { SecureGuard } from 'src/app/services/Guards/secure.service';
import { KbPipesModule } from 'src/app/pipes/kb-pipes.module';
import { of } from 'rxjs';
import { onlineOderingGuard } from 'src/app/services/Guards/onlineOrdering/online-odering.guard';

export const canDeactivate: CanDeactivateFn<KbQuickorderformComponent> = (component: KbQuickorderformComponent) => {
    const isQuickOrderFormDirtyOrInvalid = checkQuickOrderFormDirtyOrInvalid(component);
    const content = `Leave form?
                      Changes You made may not be saved`;
    return of(isQuickOrderFormDirtyOrInvalid ? confirm(content) : true);
}

export function checkQuickOrderFormDirtyOrInvalid(component: KbQuickorderformComponent) {
    if (component.myForm && component.myForm.dirty) {
        return true;
    }
    return false;
}
@NgModule({
    declarations: [KbQuickorderformComponent, KbQuickorderErrPopupComponent, AddtocartPopupConfirmationComponent],
    imports: [
        CommonModule,
        RouterModule,
        UrlModule,
        IconModule,
        I18nModule,
        MatDialogModule,
        MatButtonModule,
        MatIconModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatInputModule,
        MatFormFieldModule,
        MatCheckboxModule,
        FormsModule,
        ReactiveFormsModule,
        FormErrorsModule,
        KeyboardFocusModule,
        MediaModule,
        BsDatepickerModule,
        KbPipesModule,
        RouterModule.forChild([
            {
                path: 'quickOrderPage',
                data: { pageLabel: '/quickOrderPage' },
                component: KbQuickorderformComponent,
                canActivate: [CmsPageGuard,onlineOderingGuard],
                canDeactivate: [canDeactivate],
            }
        ]),
    ],
    exports: [KbQuickorderformComponent, KbQuickorderErrPopupComponent, AddtocartPopupConfirmationComponent],
    providers: [
        provideConfig({
            cmsComponents: {
                KbQuickOrderInfoFlexComponent: {
                    component: KbQuickorderformComponent,
                    guards: [SecureGuard, AuthGuard]
                },
            },
        }),
    ],
})
export class QuickOrderFormModule { }
